import React, { Component } from "react";
import { freeTokenAddress, freeTokenAbi } from "../FreeToken.js";
import history from "./../history";
import "../Center.css";
import Loader from "react-loader-spinner";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
const Web3 = require("web3");

let web3;
let FreeToken;

class GetToken extends Component {
  state = {
    txSent: ""
  };

  async componentDidMount() {
    web3 = new Web3(window.web3.currentProvider);
    FreeToken = new web3.eth.Contract(freeTokenAbi, freeTokenAddress);
  }

  nextScreen = async event => {
    event.preventDefault();
    const accounts = await web3.eth.getAccounts();
    await FreeToken.methods
      .mint()
      .send({
        from: accounts[0]
      })
      .on("transactionHash", receipt => {
        const txSent = true;
        this.setState({
          txSent
        });
      })
      .on("receipt", receipt => {
        history.push(`${process.env.PUBLIC_URL}/StartDemo`);
      });
  };

  render() {
    let txSent = "";
    if (this.state.txSent) {
      txSent = (
        <div>
          Please be patient and wait for the transaction to be confirmed
          <Loader type="ThreeDots" color="#1d1f7a" height={30} width={30} />
        </div>
      );
    } else {
      txSent = "";
    }

    return (
      <div className="Start">
        <div className="lander">
          <form>
            <h1>Get Some Tokens</h1>
            <p>Now, let's get some fresh FRT sent to your wallet!</p>

            <div className="row">
              <div className="col-md-4">
                <button
                  type="button"
                  className="primary-btn btn-block"
                  onClick={this.nextScreen}
                >
                  Get Tokens
                </button>
              </div>
            </div>
            <p style={{ marginTop: "24px" }} className="bottom">
              {txSent}
            </p>
          </form>
        </div>
      </div>
    );
  }
}

export default GetToken;
